import { render } from "./GastoServicioPersonalSubrogacionComponent.vue?vue&type=template&id=00a803e2&scoped=true"
import script from "./GastoServicioPersonalSubrogacionComponent.vue?vue&type=script&lang=js"
export * from "./GastoServicioPersonalSubrogacionComponent.vue?vue&type=script&lang=js"

import "./GastoServicioPersonalSubrogacionComponent.vue?vue&type=style&index=0&id=00a803e2&scoped=true&lang=css"

import exportComponent from "/Users/luismanuel/Documents/www/tuxtlacomovamos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00a803e2"]])

export default __exports__